export const MARQUES = ['Phonak', 'Unitron', 'Hansaton', 'Starkey', 'Oticon', 'Bernafon', 'Philips', 'Signia', 'Rexton', 'Biotone', 'Widex'];
export const MARQUES_PHONAK_GROUP = ['Phonak', 'Unitron', 'Hansaton'];
export const MARQUES_OTICON_GROUP = ['Oticon', 'Bernafon', 'Philips'];
export const MARQUES_WSA_GROUP = ['Signia', 'Rexton', 'Biotone', 'Widex'];

// Kept for backward compatibility (refabrication loading)
export const MARQUES_BAGUE_GROUP = ['Signia', 'Rexton', 'Biotone', 'Oticon', 'Bernafon', 'Philips', 'Widex'];

export const MODELES = {
  'Phonak': ['Audéo Lumity', 'Audéo Paradise', 'Audéo Marvel', 'Audéo Fit', 'Audéo Infinio'],
  'Unitron': ['Moxi Vivante', 'Moxi Blu', 'Moxi Jump R'],
  'Hansaton': ['Sound HD IX', 'AQ Sound SHD'],
  'Starkey': ['Genesis AI', 'Evolv AI', 'Livio Edge AI'],
  'Oticon': ['Real', 'More', 'Own', 'Zircon'],
  'Bernafon': ['Encanta', 'Alpha XT', 'Viron'],
  'Philips': ['HearLink'],
  'Signia': ['Pure Charge&Go IX', 'Pure Charge&Go AX', 'Styletto AX', 'SILK'],
  'Rexton': ['Reach R', 'Reach IX', 'M-Core iX', 'INOX'],
  'Biotone': ['Ally 4', 'Trust 4', 'Rely 4'],
  'Widex': ['SmartRIC', 'Moment Sheer', 'Moment']
};

export const FORMES_EMBOUT = [
  { value: 'canule', label: 'Canule' },
  { value: 'micro_canule', label: 'Micro-canule' },
  { value: 'canule_epaulement', label: 'Canule Epaulement' },
  { value: 'canule_demi_epaulement', label: 'Canule Demi-épaulement' },
  { value: 'fond_conque', label: 'Fond de conque' },
  { value: 'demi_conque', label: 'Demi conque' },
  { value: 'squelette', label: 'Squelette' },
  { value: 'pince_de_crabe', label: 'Pince de crabe' }
];

// BTE-specific forme list — Micro-canule is RIC-only and is therefore omitted here.
export const FORMES_EMBOUT_BTE = [
  { value: 'canule', label: 'Canule' },
  { value: 'canule_epaulement', label: 'Canule Epaulement' },
  { value: 'canule_demi_epaulement', label: 'Canule Demi-épaulement' },
  { value: 'fond_conque', label: 'Fond de conque' },
  { value: 'demi_conque', label: 'Demi conque' },
  { value: 'squelette', label: 'Squelette' },
  { value: 'pince_de_crabe', label: 'Pince de crabe' }
];

export const FORME_IMAGES = {
  canule: '/images/formes/ric_canule.png',
  micro_canule: '/images/formes/ric_micro_canule.png',
  canule_epaulement: '/images/formes/ric_canule_epaulement.png',
  canule_demi_epaulement: '/images/formes/ric_canule_epaulement.png',
  canule_evidee: '/images/formes/canule_evidee.jpg',
  fond_conque: '/images/formes/ric_fond_conque.png',
  demi_conque: '/images/formes/ric_demi_conque.png',
  squelette: '/images/formes/ric_squelette.png',
  pince_de_crabe: '/images/formes/pince_crabe.png'
};

// RIC-specific forme images (Écouteur déporté). Used when emboutType === 'ecouteur_deporte'.
export const FORME_IMAGES_RIC = {
  canule: '/images/formes/ric_canule.png',
  micro_canule: '/images/formes/ric_micro_canule.png',
  canule_epaulement: '/images/formes/ric_canule_epaulement.png',
  canule_demi_epaulement: '/images/formes/ric_canule_epaulement.png',
  canule_evidee: '/images/formes/canule_evidee.jpg',
  fond_conque: '/images/formes/ric_fond_conque.png',
  demi_conque: '/images/formes/ric_demi_conque.png',
  squelette: '/images/formes/ric_squelette.png',
  pince_de_crabe: '/images/formes/pince_crabe.png'
};

// BTE-specific forme images (Contour d'oreille). Used when emboutType === 'bte'.
// Forms without a dedicated BTE rendering fall back to the RIC asset.
export const FORME_IMAGES_BTE = {
  canule: '/images/formes/bte_canule.png',
  canule_epaulement: '/images/formes/bte_canule_epaulement.png',
  canule_demi_epaulement: '/images/formes/bte_canule_epaulement.png',
  fond_conque: '/images/formes/bte_fond_conque.png',
  demi_conque: '/images/formes/bte_demi_conque.png',
  squelette: '/images/formes/bte_squelette.png',
  pince_de_crabe: '/images/formes/pince_crabe.png'
};

export const EVENT_SIZES = ['Sans', '0.5', '1', '1.5', '2', '2.5', '3', 'MAX'];

export const EMBOUT_TYPES = [
  { value: 'bte', label: 'BTE (Contour d\'oreille)' },
  { value: 'ecouteur_deporte', label: 'Ecouteur deporté (RIC)' },
  { value: 'integral', label: 'Intégral (écouteur intégré)' },
  { value: 'silk', label: 'Intra (Silk / INOX)' }
];

export const INTEGRAL_VERSIONS = [
  { value: '5.0', label: '5.0' },
  { value: '6.0', label: '6.0' }
];

export const INTEGRAL_PUISSANCES = [
  { value: 'S', label: 'S (Standard)' },
  { value: 'M', label: 'M (Medium)' },
  { value: 'P', label: 'P (Power)' },
  { value: 'UP', label: 'UP (Ultra Power)' }
];

// Cable lengths available for integral embouts. "00" is only valid for v6.0
export const INTEGRAL_CABLE_LENGTHS_60 = [
  { value: '00', label: '00' },
  { value: '0', label: '0' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' }
];

export const INTEGRAL_CABLE_LENGTHS_50 = [
  { value: '0', label: '0' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' }
];

// Production delay (business hours) per embout type
// Default: 72h (3 business days). Integral: 120h (5 business days).
export const PRODUCTION_DELAY_HOURS = {
  default: 72,
  integral: 120,
};

export const OBTURATEUR_TYPES = [
  // « Anti-Eau flottant » n'est plus une entrée séparée : la variante flottante
  // est désormais activée via une case à cocher dans les options de l'Anti-Eau.
  { value: 'anti_eau', label: 'Anti-Eau' },
  { value: 'anti_bruit_non_filtre', label: 'Anti-bruit non filtré' },
  { value: 'anti_bruit_filtre', label: 'Anti-bruit filtré' },
  { value: 'bouchon_musique', label: 'Bouchon musique' }
];

// Formes possibles pour un obturateur (dépend du sous-type). Utilisé pour
// afficher dans les récapitulatifs client/technicien la forme choisie et son
// visuel — sans devoir rescanner le formulaire.
export const OBTURATEUR_FORMES = {
  // Anti-bruit non filtré
  solide_plug_poignee: { label: 'Solide plug + poignée', image: '/images/formes/obturateur_poignee.png' },
  fond_conque_confort: { label: 'Fond de conque confort', image: '/images/formes/antibruit_non_filtre.png' },
  fond_conduit_discret: { label: 'Fond de conduit discret', image: '/images/formes/obturateur_fond_conduit_discret.png' },
  // Anti-bruit filtré / Bouchon musique
  canule: { label: 'Canule', image: '/images/formes/filtre_canule.png' },
  fond_conque: { label: 'Fond de conque', image: '/images/formes/filtre_fond_conque.png' },
};

// Fallback : illustration par défaut pour chaque type d'obturateur, utilisée
// lorsque la commande n'a pas de `obturateur_forme` explicite (par exemple
// une anti-eau créée avant l'introduction du champ forme, ou tout obturateur
// dont la forme n'est pas référencée dans OBTURATEUR_FORMES).
export const OBTURATEUR_TYPE_DEFAULT_IMAGE = {
  anti_eau: '/images/formes/antieau.png',
  anti_eau_flottant: '/images/formes/antieau.png',
  anti_bruit_non_filtre: '/images/formes/antibruit_non_filtre.png',
  anti_bruit_filtre: '/images/formes/antibruit_filtre.png',
  bouchon_musique: '/images/formes/bouchon_musique.jpg',
};

/**
 * Retourne le chemin d'image de la forme d'embout, en tenant compte du type
 * d'embout (RIC vs BTE vs autre) — le même mot-clé (`canule_epaulement`) renvoie
 * à des visuels différents selon la famille produit.
 */
export function getEmboutFormeImage(emboutType, forme) {
  if (!forme) return null;
  if (emboutType === 'bte' && FORME_IMAGES_BTE[forme]) return FORME_IMAGES_BTE[forme];
  if (emboutType === 'ecouteur_deporte' && FORME_IMAGES_RIC[forme]) return FORME_IMAGES_RIC[forme];
  return FORME_IMAGES[forme] || null;
}

/**
 * Retourne l'illustration à afficher pour un obturateur, en s'appuyant en
 * priorité sur la forme choisie, puis en repli sur le type d'obturateur.
 */
export const ANTI_EAU_TYPES = ['anti_eau', 'anti_eau_flottant'];

// Libellé de la forme d'un obturateur. Les anti-eau sont TOUJOURS « Fond de conque »
// (quelle que soit la valeur historiquement stockée).
export function getObturateurFormeLabel(obturateurType, obturateurForme) {
  if (ANTI_EAU_TYPES.includes(obturateurType)) return 'Fond de conque';
  if (!obturateurForme) return '';
  return OBTURATEUR_FORMES[obturateurForme]?.label || String(obturateurForme).replace(/_/g, ' ');
}

// Libellé lisible d'une forme d'embout (ex. canule_demi_epaulement → Canule Demi-épaulement).
export function getEmboutFormeLabel(forme) {
  if (!forme) return '';
  if (forme === 'silk') return 'Intra (Silk) — forme unique';
  return FORMES_EMBOUT.find(f => f.value === forme)?.label || String(forme).replace(/_/g, ' ');
}

// Puissance écouteur affichée selon le groupe de marque (évite les champs résiduels d'un autre groupe).
// side : 'od' | 'og' | undefined (unilatéral).
export function getPuissanceDisplay(opts, side) {
  if (!opts) return '';
  const sfx = side ? `_${side}` : '';
  const marque = opts.marque || '';
  const wsa = opts[`ecouteur_puissance_wsa${sfx}`] || opts.ecouteur_puissance_wsa;
  const oticon = opts[`ecouteur_puissance_oticon${sfx}`] || opts.ecouteur_puissance_oticon;
  const phonak = opts[`ecouteur_puissance${sfx}`] || opts.ecouteur_puissance;
  if (MARQUES_WSA_GROUP.includes(marque) || (!marque && wsa)) {
    return wsa ? [opts.ecouteur_version_wsa, wsa].filter(Boolean).join(' ') : '';
  }
  if (MARQUES_OTICON_GROUP.includes(marque) || (!marque && oticon)) return oticon || '';
  return phonak || oticon || wsa || '';
}

export function getObturateurIllustration(obturateurType, obturateurForme) {
  if (ANTI_EAU_TYPES.includes(obturateurType)) {
    return { label: 'Fond de conque', image: OBTURATEUR_TYPE_DEFAULT_IMAGE[obturateurType] };
  }
  if (obturateurForme && OBTURATEUR_FORMES[obturateurForme]) {
    return OBTURATEUR_FORMES[obturateurForme];
  }
  if (obturateurType && OBTURATEUR_TYPE_DEFAULT_IMAGE[obturateurType]) {
    return { image: OBTURATEUR_TYPE_DEFAULT_IMAGE[obturateurType], label: obturateurForme ? String(obturateurForme).replace(/_/g, ' ') : '' };
  }
  return null;
}


// ---------------------------------------------------------------------------
// MATIÈRES × DURETÉS × COULEURS — source de vérité : tableau « Liste Silicones
// disponibles » (Juin 2026). Toutes les couleurs sont au même prix (plus de
// supplément « couleur premium »).
// ---------------------------------------------------------------------------
export const MATERIAL_LABELS = {
  silicone: 'Silicone',
  resine_3d: 'Résine 3D',
  resine_souple: 'Résine souple',
};
export const materialLabel = (m) => MATERIAL_LABELS[m] || m || '—';

// Duretés proposées par matière (la résine 3D n'a pas de dureté).
export const SHORE_BY_MATERIAL = {
  silicone: ['25', '35', '40', '60'],
  resine_souple: ['70', '90'],
};
export const SHORE_LABELS = {
  '25': '25 SH (Très souple)',
  '35': '35 SH AQUAPLUS (Souple)',
  '40': '40 SH (Standard)',
  '60': '60 SH (Ferme)',
  '70': '70 SH (Résine souple)',
  '90': '90 SH (Résine souple)',
};
export const shoreLabel = (s) => SHORE_LABELS[String(s)] || (s ? `${s} SH` : '—');
export const getShoresForMaterial = (m) => SHORE_BY_MATERIAL[m] || [];
export const materialHasShore = (m) => Boolean(SHORE_BY_MATERIAL[m]);

// Couleur × dureté (silicone uniquement). Les résines sont toujours transparentes.
// rouge_bleu / bleu_rouge (appairé D/G) = intersection Rouge ∩ Bleu.
export const COLOR_SHORE_MATRIX = {
  transparent: ['25', '40', '60'],
  rose: ['25', '40'],
  rouge: ['25', '35', '40'],
  bleu: ['25', '35', '40'],
  noir: ['35', '40'],
  orange: ['35', '40'],
  fuchsia: ['40'],
  rouge_bleu: ['25', '35', '40'],
  bleu_rouge: ['25', '35', '40'],
};
export const COLOR_ORDER = ['transparent', 'rose', 'bleu_rouge', 'rouge_bleu', 'rouge', 'bleu', 'orange', 'noir', 'fuchsia'];
export const COLOR_LABELS = {
  transparent: 'Transparent',
  rose: 'Rosé',
  rouge: 'Rouge',
  bleu: 'Bleu',
  orange: 'Orange',
  noir: 'Noir',
  fuchsia: 'Fuchsia',
  bleu_rouge: 'Bleu/Rouge',
  rouge_bleu: 'Rouge (D) / Bleu (G)',
};
export const colorLabel = (c) => COLOR_LABELS[c] || (c ? c.charAt(0).toUpperCase() + c.slice(1) : '—');

// Compat : plus de supplément couleur. Conservé (vide) pour les anciens imports.
export const PREMIUM_SILICONE_COLORS = [];
export const PREMIUM_COLOR_OPTION_KEY = 'option_couleur_silicone_premium';
export const PREMIUM_COLOR_LABELS = COLOR_LABELS;
export const PREMIUM_COLOR_ALLOWED_SHORE = COLOR_SHORE_MATRIX;

export function isPremiumColor(couleur) {
  return PREMIUM_SILICONE_COLORS.includes(couleur);
}

// Une couleur est-elle disponible pour cette dureté silicone ?
export function isShoreAllowedForColor(couleur, shore) {
  const allowed = COLOR_SHORE_MATRIX[couleur];
  if (!allowed) return true;
  return allowed.includes(String(shore));
}

// Couleurs disponibles pour TOUTES les duretés fournies (bilatéral : OD et OG).
export function getAvailableColors(shores) {
  const list = (Array.isArray(shores) ? shores : [shores]).filter(Boolean).map(String);
  return COLOR_ORDER.filter((c) => list.every((s) => isShoreAllowedForColor(c, s)));
}

// Première dureté compatible avec la couleur (fallback si la dureté courante ne l'est pas).
export function getDefaultShoreForColor(couleur) {
  const allowed = COLOR_SHORE_MATRIX[couleur];
  if (!allowed || !allowed.length) return null;
  return allowed.includes('40') ? '40' : allowed[0];
}
export const getDefaultShoreForPremiumColor = getDefaultShoreForColor;

export const ATTENUATIONS_ER = [
  { value: 'ER-9', label: 'Filtre ER-9' },
  { value: 'ER-15', label: 'Filtre ER-15' },
  { value: 'ER-25', label: 'Filtre ER-25' }
];

export const FILTRE_ER_IMAGES = {
  'ER-9': '/images/filtres/er_9.jpg',
  'ER-15': '/images/filtres/er_15.jpg',
  'ER-25': '/images/filtres/er_25.jpg'
};

export const ATTENUATIONS_ELACIN = [
  { value: 'RC-15', label: 'Filtre Elacin RC-15' },
  { value: 'RC-17', label: 'Filtre Elacin RC-17' },
  { value: 'RC-19', label: 'Filtre Elacin RC-19' },
  { value: 'RC-21', label: 'Filtre Elacin RC-21' },
  { value: 'RC-23', label: 'Filtre Elacin RC-23' },
  { value: 'RC-25', label: 'Filtre Elacin RC-25' },
  { value: 'RC-27', label: 'Filtre Elacin RC-27' },
  { value: 'RC-29', label: 'Filtre Elacin RC-29' }
];

// Résout un libellé lisible pour une valeur d'atténuation obturateur, quelle
// que soit la famille (ER = anti-bruit filtré ancien, Elacin RC = anti-bruit
// filtré actuel / bouchon musique). Utilisé dans les récaps client/tech.
export function getObturateurAttenuationLabel(value) {
  if (!value) return '';
  const found = [...ATTENUATIONS_ER, ...ATTENUATIONS_ELACIN].find(a => a.value === value);
  return found ? found.label : String(value);
}


export const FILTRE_ELACIN_IMAGES = {
  'RC-15': '/images/filtres/elacin_rc_15.png',
  'RC-17': '/images/filtres/elacin_rc_17.png',
  'RC-19': '/images/filtres/elacin_rc_19.png',
  'RC-21': '/images/filtres/elacin_rc_21.png',
  'RC-23': '/images/filtres/elacin_rc_23.png',
  'RC-25': '/images/filtres/elacin_rc_25.png',
  'RC-27': '/images/filtres/elacin_rc_27.png',
  'RC-29': '/images/filtres/elacin_rc_29.png'
};

export const MONTAGE_MESSAGES = {
  slim_tip_link: "Le montage inclura un plastic bushing et un filtre (choix CeruStop ou HF4).",
  montage_tube: "L'ecouteur sera inséré à travers l'embout via un tube. Aucun plastic bushing ni cerustop ne sera monté.",
  montage_tube_lock: "L'ecouteur sera inséré via un tube avec verrouillage (tube lock). Disponible uniquement pour les embouts BTE en silicone.",
  montage_tube_enfant: "Tube de diamètre réduit (2,5 mm) adapté aux jeunes patients. Le diamètre adulte standard est de 3 mm.",
  montage_bague_prodition: "Un filtre ProWax sera placé sur la bague, permettant l'emboitement direct de l'ecouteur dans la bague en silicone.",
  montage_bague_wsa: "Une bague WSA adaptée sera installée, permettant la fixation de l'ecouteur par emboitement ou clic.",
  montage_bague_3dsa: "La bague 3DSA permet de clipser directement l'écouteur 5.0 ou 6.0 à travers la bague, positionnant le cerustop à fleur de l'embout. Aucun collage n'est nécessaire. Attention : cette bague étant assez large, elle ne peut être posée que pour des conduits larges."
};

export const MONTAGE_LABELS = {
  slim_tip_link: 'SlimTip Link',
  montage_tube: 'Montage tube',
  montage_tube_lock: 'Montage tube lock',
  montage_tube_enfant: 'Tube enfant (2,5 mm)',
  montage_bague_prodition: 'Montage bague',
  montage_bague_wsa: 'Montage bague',
  montage_bague_3dsa: 'Bague 3DSA'
};

// Rendu contextuel : pour le groupe Phonak (RIC), le montage tube s'appelle « Click tube ».
export function getMontageLabel(montageType, marque) {
  const PHONAK_LIKE = ['Phonak', 'Unitron', 'Hansaton'];
  if (montageType === 'montage_tube' && marque && PHONAK_LIKE.includes(marque)) {
    return 'Click tube';
  }
  return MONTAGE_LABELS[montageType] || montageType;
}
